<!-- <app-loader *ngIf="isLoading"></app-loader> -->

<div class="dialog-header">
    <h6>Add Service</h6>
    <button class="add-multiple-service" (click)="addService()">
        Add Service Row
        <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
    </button>

    <button mat-icon-button class="close-icon" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<form [formGroup]="serviceFormGroup" (ngSubmit)="onSubmit()">

    <div formArrayName="services" class="services-scroll">
        <div class="service" *ngFor="let service of serviceForm.controls; let i = index" [formGroupName]="i">
            <!-- <button mat-icon-button type="button" *ngIf="serviceForm.length > 1" (click)="removeService(i)" -->
            <!-- class="delete-button"> -->
            <!-- <mat-icon fontSet="material-symbols-outlined" class="delete-icon">delete</mat-icon> -->
            <!-- </button> -->
            <!-- <div class="field-section"> -->
            <div class="input-fields">
                <mat-form-field appearance="outline">
                    <mat-label>Service</mat-label>
                    <input matInput formControlName="name"
                        (keypress)="disallowNumericData($event); allowLimitedInput($event, 50)"
                        (paste)="onPaste($event, i, 'name')" (blur)="onInputTrim(i, 'name')" />
                    <mat-error *ngIf="service.get('name')?.hasError('required')">
                        Service Name is required.
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Amount({{data.fromCurrency}}) </mat-label>
                    <input type='number' matInput formControlName="agentValueFromCurrency"
                        (blur)="onInputTrim(i, 'agentValueFromCurrency')"
                        (input)="convertCurrency(service, 'fromCurrency')" />
                    <mat-error *ngIf="service.get('agentValueFromCurrency')?.hasError('required')">
                        Amount is required.
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Amount({{data.toCurrency}})</mat-label>
                    <input type='number' matInput formControlName="agentValueToCurrency"
                        (blur)="onInputTrim(i, 'agentValueToCurrency')"
                        (input)="convertCurrency(service, 'toCurrency')" />
                </mat-form-field>


                <button mat-icon-button type="button" *ngIf="serviceForm.length > 1" (click)="removeService(i)"
                    class="delete-button">
                    <mat-icon fontSet="material-symbols-outlined" class="delete-icon">delete</mat-icon>
                </button>
            </div>
            <mat-form-field appearance="outline" class="remark-field">
                <mat-label>Remark</mat-label>
                <textarea matInput rows="2" formControlName="remark" (blur)="onInputTrim(i, 'agentValue')"></textarea>
            </mat-form-field>

        </div>
    </div>
    <div>
        <button mat-flat-button color="primary" type="submit" class="add-service">
            Save Service
        </button>
    </div>
</form>